// extracted by mini-css-extract-plugin
export var form = "form-elem-module--form--3mryI";
export var form_inner = "form-elem-module--form_inner--scq5l";
export var form_field = "form-elem-module--form_field--2tfzz";
export var form_checkbox = "form-elem-module--form_checkbox--26UGE";
export var form_submit = "form-elem-module--form_submit--1gb6k";
export var disable = "form-elem-module--disable--2byJ5";
export var additional = "form-elem-module--additional--1QRFT";
export var hidden = "form-elem-module--hidden--2_eYg";